import React, { useEffect, useState } from "react"
import { Button, Card, Grid } from "@mui/material"
import { WBInput, WBSelect } from "components/_WBcomponents/WBInput"
import { statusOptions } from "helper/constant"
import { loadUser } from "services/userService"
import DateRangeInput from "components/_WBcomponents/InputDateRange"
import { getEventList } from "services/eventService"
import AsyncSelect from 'react-select/async';
import { WBLabel } from "components/_WBcomponents/WBLabel"
import { getAdminList } from "services/adminService"
import { getExpenseType } from "services/expenseService"

function ExpenseFilter ({
    filter,
    onChangeFilter,
    onClear
}) {

    const [ eventList, setEventList ] = useState([])
    const [ adminList, setAdminList ] = useState([])
    const [ expenseType, setExpenseType ] = useState([])

    // dateType,
    // startDate,
    // endDate,
    // expenseType,
    // requestBy,
    // eventId
    
    useEffect(() => {
        loadEventList()
        loadAdmin()
        loadExpenseType()
    }, [])

    const loadEventList = async () => {
        let { data, error } = await getEventList({})
        if (error) { console.log(error) }
        if (data) {
            let dataList = []
            data.map(v => {
                dataList.push({
                    value: v._id,
                    label: v.eventName,
                    data: v
                })
            })
            setEventList(dataList)
        }
    }

    const loadAdmin = async () => {
        let { data, error } = await getAdminList()
        if (error) { return ([]) }
        if (data) {
            let dataList = []
            if (data.length <= 0) return
            data.map(value => {
                dataList.push({
                    label: value.name,
                    value: value._id,
                    data: value
                })
            })
            setAdminList(dataList)
        }
    }

    const loadExpenseType = async () => {
        let { data, error } = await getExpenseType()
        if (error) { console.log(error) }
        if (data) { 
            setExpenseType(data.map(v => {
                return {
                    value: v._id,
                    label: v.name
                }
            }))
        }
    }

    return (
        <Grid>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                    <DateRangeInput
                        label={'Order Date'}
                        showLabel={true}
                        startDate={filter.startDate || ''}
                        endDate={filter.endDate || ''}
                        dateRangeType={filter.dateType || ''}
                        onChangeSelect={(e) => onChangeFilter({ dateType: e })}
                        onChangeStartDate={(e) => onChangeFilter({ startDate: e })}
                        onChangeEndDate={(e) => onChangeFilter({ endDate: e })}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <WBSelect label={"Event"} 
                        options={eventList}
                        value={filter.eventId}
                        onChange={(e) => {
                            onChangeFilter({eventId: e})
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <WBSelect label={"Request By"} 
                        options={adminList}
                        value={filter.requestBy}
                        onChange={(e) => {
                            onChangeFilter({requestBy: e})
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={2}>
                    <WBSelect label={"Expense Type"} 
                        options={expenseType}
                        value={filter.expenseType}
                        onChange={(e) => {
                            onChangeFilter({expenseType: e})
                        }}
                    />
                </Grid>
                <Grid item xs sm textAlign={"right"}>
                    <div style={{marginTop: 20}}/>
                    <Button variant="outlined" onClick={onClear}>Clear</Button>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default ExpenseFilter